export default {"src":"/_next/static/media/plus.3dbcf26a.svg","height":20,"width":20};